<template>
  <div ref="dom" class="charts chart-pie"></div>
</template>

<script>
import * as echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartPie",
  props: {
    value: Array,
    text: String,
    subtext: String,
  },
  data() {
    return {
      dom: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        if(val.length){
          console.log(val);
        this.loadEcharts(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      this.$nextTick(() => {
        let total = 0;
        val.forEach((v) => (total += v.value));
        let option = {
          color: ["#fad540", "#4d88ff", "#6967f4"],
          tooltip: {
            trigger: "item",
          },
          legend: {
            bottom: "8%",
            left: "center",
            icon: "circle",
            formatter: function (name) {
              let leg = val.filter((item) => item.name == name);
              let legendName =
                  name + "  " + ((leg[0].value / total) * 100).toFixed(2) + "%";
              return legendName;
            },
            textStyle: {
              fontSize: 14,
            },
          },
          series: [
            {
              name: "新生报到人数统计",
              type: "pie",
              center: ["50%", "40%"],
              radius: ["0", "60%"],
              startAngle: -60,
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 5,
                borderColor: "#fff",
                borderWidth: 4,
              },
              emphasis: {
                // label: {
                //   show: true,
                //   fontSize: "40",
                //   fontWeight: "bold",
                // },
              },
              label: {
                show: true,
                position: "outside",
                padding: [0, -80],
                formatter: "{b} : {c} \n",
              },
              labelLine: {
                show: true,
                length: 20,
                length2: 80,
                align: "right",
                lineStyle: {
                  width: 1,
                },
              },
              data: val,
            },
          ],
        };
        if (this.dom != null && this.dom != "" && this.dom != undefined) {
          this.dom.dispose();
        }
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },

  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>
